import React, { useEffect } from "react";
import Navbar from "../../component/Navbar/Navbar";
import CreateTable from "../../component/CreateTable/CreateTable";
import { MdDelete, MdTableRestaurant } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import {
  deleteTable,
  getTables,
  selectTables,
} from "../../redux/features/table/TableSlice";
import EditTable from "../../component/EditTable/EditTable";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";

const Table = () => {

  const tables = useSelector(selectTables);
  const dispatch = useDispatch();
  const confirmDelete = (id, tableNo) => {
    if (!id || !tableNo) {
      toast.error("ID or tableNo is undefined");
      return;
    }
    confirmAlert({
      title: "Delete This Table",
      message: `Are you sure to delete this ${tableNo}?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => removeTable(id),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };
  const removeTable = async (id) => {
    await dispatch(deleteTable(id));
    dispatch(getTables());
  };
  useEffect(() => {
    dispatch(getTables());
  }, [dispatch]);
  return (
    <div className="overflow-hidden flex flex-col h-screen bg-[#F1F1F1]">
      <Navbar page={"Table"} />

      <div className="w-full md:p-8 py-6 px-4 relative overflow-y-auto h-full   scrollbar-hide ">
        {/* Product List */}
        {tables?.length > 0 ? (
          <>
            <div className="flex justify-center items-center  md:gap-6 gap-3  flex-wrap">
              {tables?.map((table) => (
                <div
                  key={table._id}
                  className="md:w-52 md:h-44 w-36 h-32 relative bg-[#9fa09fa8] overflow-hidden rounded-2xl md:p-4 p-2 flex flex-col justify-between items-center "
                >
                  <h1 className="flex-1 flex-grow flex justify-center items-center text-white md:text-[1.5rem] text-[1.2rem] uppercase font-semibold">
                    {table?.tableNo}
                  </h1>
                  <div className="flex justify-between items-center border-t md:p-1 p-[2px] md:text-[1rem] text-[.8rem] text-white w-full">
                    <span className=" capitalize">
                      {table?.tableStatus === "outOfService"
                        ? "Out of Service"
                        : table?.tableStatus}
                    </span>
                    {table?.personSpace && <span>{table?.personSpace}</span>}
                  </div>
                  <EditTable id={table._id} />
                  <button
                    onClick={() => confirmDelete(table._id, table.tableNo)}
                    className="absolute text-white bg-[#fa3426cc] rounded-lg p-[4px] md:top-3 md:left-3 top-2 left-2"
                  >
                    <MdDelete className="size-4" />
                  </button>
                </div>
              ))}
            </div>
            <CreateTable />
          </>
        ) : (
          <div className="w-full flex items-center h-full justify-center">
            <div className="w-[29rem] lg:w-[38rem]  relative  lg:h-[30rem] h-[23rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
              <MdTableRestaurant className="size-36" />

              <p className="text-[1rem] md:text-[1.5rem] font-inter-700 text-center">
                You have no table yet
              </p>
              <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                To add a table, press the (+) button
              </p>
              <CreateTable />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Table;
